import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { statusFormDefault } from "@factory/form/form.default";
import { StatusFormRule, StatusFormSchema } from "@factory/form/form.rule";
import { useQyCreateStatus } from "@factory/query/status.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewStatus() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateStatus } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Status is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addStatus, isLoading: isCreating } =
    useQyCreateStatus(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<StatusFormSchema>({
    defaultValues: statusFormDefault,
    resolver: zodResolver(StatusFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: StatusFormSchema) => {
    const formData = mapCreateStatus(form);
    addStatus(formData);
  };
  const handleValidateError = (err: FieldErrors<StatusFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
